import '../../src/css/pages/attendancePages.scss';

import '../../src/js/runtime';
import startStimulus from '../../src/js/startStimulus';

import QRCodePullController from '../../src/js/controllers/qr_code_pull_controller';
import ClockController from '../../src/js/controllers/clock_controller';

startStimulus([{ qr_code: QRCodePullController }, { clock: ClockController }]);
